module.exports = {
  roleTableBtn: [
    {
      id: 'edit',
      name: '修改',
      dataStatus: '1',
      isNoConfirm: true // 不需要弹窗询问
    },
    {
      id: 'delete',
      name: '删除',
      dataStatus: '1',
      warnTxt: '删除后将不能恢复，确定删除吗？',
      isNoConfirm: false // 不需要弹窗询问
    }
  ],
  roleTableHead: [
    {
      label: '角色名称',
      key: 'name'
    }, {
      label: '角色编码',
      key: 'roleCode'
    }, {
      label: '状态',
      key: 'status'
    },
    {
      label: '描述',
      key: 'description'
    },
    {
      label: '最新修改时间',
      key: 'updateTime'
    }
  ],
  menuLimitTableHead: [
    {
      label: '菜单名称',
      key: 'name'
    }, {
      label: 'CODE&URL',
      key: 'code'
    },
    {
      label: '状态',
      key: 'status',
      type: 'switch'
    }
  ],
  dataLimitTableHead: [
    {
      label: '平台',
      key: 'platform'
    }, {
      label: '品牌',
      key: 'brand'
    },
    {
      label: '状态',
      key: 'status',
      type: 'switch'
    }
  ]
}
